var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang-switcher"},_vm._l((_vm.langs),function(lang){return _c('button',{key:lang,staticClass:"lang-switcher__btn",class:{ 'lang-switcher__btn--active': _vm.currentLang === lang },on:{"click":function($event){return _vm.switchLang(lang)}}},[_vm._v(" "+_vm._s(lang.toUpperCase())+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }